/**
 * `@ngweditor/react` 가 모듈 평가 시점에 전역 주입하는 `<style id="ngw-editor-injected-styles">`
 * (tokens/tailwind/preflight 등 1,100+ 규칙)의 활성 구간을 "에디터가 떠 있는 동안"으로 한정하는 게이트.
 *
 * 이 시트는 무스코프 element 셀렉터(tailwind preflight 등)를 포함해, 요소가 많은 메일 본문
 * (24k 요소 실측)의 전역 스타일 매칭 비용을 키운다 — Safari(WebKit) 본문 paint 3.4s 중 ~2.1s,
 * 시트 비활성 시 1.3s. 에디터가 없는 동안 sheet 를 disabled 로 두고, 에디터 마운트
 * (NgwEditorLifecycle.init) 동안만 활성화한다. 작성창+서명편집 동시 사용을 위해 refcount 로 관리.
 *
 * suspend 는 주입(모듈 평가)과 같은 동기 흐름에서 호출되어야 삽입↔비활성 사이에 렌더링 업데이트가
 * 끼지 않아 재계산 비용이 0 이다 — NgwEditorLifecycle 모듈 본문 최상단에서 호출된다.
 * 시트를 찾지 못하면(패키지가 id 를 바꾸는 등) 모든 함수가 no-op — 에디터 스타일은 패키지 기본
 * (항상 활성)으로 동작한다(fail-open, 기능 회귀 없음).
 */
const NGW_EDITOR_STYLE_ID = 'ngw-editor-injected-styles'

let activeEditorCount = 0

function setInjectedStyleDisabled(disabled: boolean): void {
  if (typeof document === 'undefined') return
  const el = document.getElementById(NGW_EDITOR_STYLE_ID) as HTMLStyleElement | null
  if (el == null) return
  el.disabled = disabled
  // HTMLStyleElement.disabled 는 연결된 sheet 로 전달되지만, sheet 가 이미 존재하면 직접도 지정해
  // 구현 차이(jsdom 등)에 무관하게 상태를 보장한다.
  if (el.sheet != null) {
    el.sheet.disabled = disabled
  }
}

/** 주입 직후(동기) 시트를 비활성화한다. 에디터가 이미 떠 있으면(HMR 재평가 등) 활성 유지. */
export function suspendInjectedNgwEditorStyles(): void {
  if (activeEditorCount > 0) return
  setInjectedStyleDisabled(true)
}

/** 에디터 마운트 — 시트 활성화. dispose 의 releaseNgwEditorStyles 와 짝으로 호출해야 한다. */
export function acquireNgwEditorStyles(): void {
  activeEditorCount += 1
  setInjectedStyleDisabled(false)
}

/** 에디터 해제 — 마지막 에디터가 사라지면 시트를 다시 비활성화해 뷰어 렌더 비용을 되돌린다. */
export function releaseNgwEditorStyles(): void {
  activeEditorCount = Math.max(0, activeEditorCount - 1)
  if (activeEditorCount === 0) {
    setInjectedStyleDisabled(true)
  }
}
